import InputMixin from './Input'
import $ from 'jquery'

let $shadowTextArea
let shadowTextAreaReferenceCount = 0

const createShadowTextArea = function () {
  const $shadow = $('<textarea class="km-textarea-shadow">')
  $shadow.appendTo('body')
  return $shadow
}

function destroyShadow() {
  $shadowTextArea && $shadowTextArea.remove()
  $shadowTextArea = null
}

/**
 * 会影响高度的style属性
 */
const HEIGHT_RELATIVE_STYLE = [
  'letter-spacing',
  'line-height',
  'padding-top',
  'padding-bottom',
  'font-family',
  'font-weight',
  'font-size',
  'text-rendering',
  'text-transform',
  'width',
  'text-indent',
  'padding-left',
  'padding-right',
  'border-width',
  'box-sizing',
]

export default {
  name: 'KTextArea',
  mixins: [InputMixin],
  props: {
    rows: {
      type: Number,
      default: 2,
    },
    rowsMax: {
      type: Number,
      default: 0,
    },
    rowsMin: {
      type: Number,
      default: 0,
    },
    autoSize: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean, // true => 'vertical', false => 'none'
      default: true,
      // validator: value => ['none', 'both', 'horizontal', 'vertical'].indexOf(value) > -1,
      // default: 'vertical',
    },
    // 自定义高度，不受制 rows autoSize 的影响
    height: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      mounted: false,
      isTextArea: true,
      initialized: false,
      innerAutoSize: false,
    }
  },
  computed: {
    realRowsMin() {
      if (this.rowsMin && this.rows <= this.rowsMin) {
        return this.rowsMin
      }

      if (this.rowsMax && this.rows > this.rowsMax) {
        return this.rowsMax
      }

      return this.rows
    },
  },
  watch: {
    innerValue() {
      // if (this.autoSize) {
      this.resizeTextArea()
      // }
    },
    height() {
      if (this.height) {
        this.innerAutoSize = true
      }
    },
    autoSize: {
      immediate: true,
      handler(value) {
        if (value || this.height) {
          this.innerAutoSize = true
        } else {
          this.innerAutoSize = false
        }
      },
    },
  },
  created() {
    shadowTextAreaReferenceCount++
  },
  mounted() {
    this.$original = $(this.$refs.original)
    this.$wrapper = $(this.$slots.default ? this.$refs.originalWrapper : this.$refs.originalWrapper.$el)
    this.mounted = true
    this.$nextTick(() => {
      this.resizeTextArea()
    })
  },
  destroyed() {
    shadowTextAreaReferenceCount--
    if (shadowTextAreaReferenceCount <= 0) {
      destroyShadow()
    }
  },
  methods: {
    resizeTextArea() {
      if (!this.mounted) {
        return
      }

      if (!$shadowTextArea) {
        $shadowTextArea = createShadowTextArea()
      }
      $shadowTextArea.val('')

      $shadowTextArea.css(this.$original.css(HEIGHT_RELATIVE_STYLE))

      const paddingSize =
        parseFloat($shadowTextArea.css('paddingTop')) + parseFloat($shadowTextArea.css('paddingBottom'))
      const isBorderBox = $shadowTextArea.css('boxSizing') === 'border-box'
      const borderSize =
        parseFloat($shadowTextArea.css('borderTopWidth')) + parseFloat($shadowTextArea.css('borderBottomWidth'))
      const rowHeight = $shadowTextArea[0].scrollHeight - paddingSize

      // $shadowTextArea.val(this.innerValue)
      $shadowTextArea.val(this.innerValue)

      let originalHeight = $shadowTextArea[0].scrollHeight + paddingSize + borderSize
      let overflowY = ''

      let wrapHeight = 0
      if (this.realRowsMin) {
        let minHeight = rowHeight * this.realRowsMin
        if (isBorderBox) {
          minHeight = minHeight + paddingSize + borderSize
        }
        // if (this.autoSize) {
        if (this.innerAutoSize) {
          wrapHeight = Math.max(minHeight, originalHeight)
        } else {
          wrapHeight = minHeight
        }
      }

      if (this.rowsMax) {
        let maxHeight = rowHeight * this.rowsMax
        if (isBorderBox) {
          maxHeight = maxHeight + paddingSize + borderSize
        }
        overflowY = originalHeight > maxHeight ? '' : 'hidden'
        wrapHeight = Math.min(maxHeight, originalHeight)
      }

      if (originalHeight < wrapHeight) {
        originalHeight = wrapHeight
      }

      this.$original[0].style.overflowY = overflowY
      this.$original[0].style.height = originalHeight + 'px'

      if (!this.height) {
        this.$wrapper[0].style.overflowY = overflowY
        this.$wrapper[0].style.height = wrapHeight + 'px'
      }
    },
  },
}
